import { render, staticRenderFns } from "./PersonProfilePidPendingNearMatchOverviewRow.vue?vue&type=template&id=04cc7d15&scoped=true&"
import script from "./PersonProfilePidPendingNearMatchOverviewRow.vue?vue&type=script&lang=js&"
export * from "./PersonProfilePidPendingNearMatchOverviewRow.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfilePidPendingNearMatchOverviewRow.vue?vue&type=style&index=0&id=04cc7d15&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cc7d15",
  null
  
)

export default component.exports